import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CodeFaqItem } from '../utils/codeFaq';

// Оформление и иконки (heroicons outline, MIT) — как у пополнения Steam
const BLUE = '#3657F0';

const BoltIcon: React.FC = () => (
  <svg width={15} height={15} viewBox="0 0 24 24" fill="none" stroke={BLUE} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z" />
  </svg>
);

const LockIcon: React.FC = () => (
  <svg width={15} height={15} viewBox="0 0 24 24" fill="none" stroke={BLUE} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
  </svg>
);

const StarIcon: React.FC = () => (
  <svg width={15} height={15} viewBox="0 0 24 24" fill="none" stroke={BLUE} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z" />
  </svg>
);

/** Под кнопкой оплаты: согласие с условиями и доводы магазина. */
export const PurchaseTerms: React.FC<{ buttonLabel: string }> = ({ buttonLabel }) => {
  const navigate = useNavigate();
  return (
    <div className="pt-1">
      <p className="text-center" style={{ fontSize: '12px', lineHeight: '16px', color: '#818384' }}>
        Нажимая «{buttonLabel}», вы принимаете условия{' '}
        <span className="underline font-semibold cursor-pointer" style={{ color: BLUE }} onClick={() => navigate('/terms')}>Пользовательского соглашения</span>
        {' '}и{' '}
        <span className="underline font-semibold cursor-pointer" style={{ color: BLUE }} onClick={() => navigate('/privacy')}>Политики конфиденциальности</span>
      </p>
      <div className="flex items-center justify-center gap-3 mt-3 flex-wrap">
        {[
          { icon: <BoltIcon />, t: 'Моментально' },
          { icon: <LockIcon />, t: 'Оплата по СБП' },
          { icon: <StarIcon />, t: '5 000+ отзывов' },
        ].map((b) => (
          <span key={b.t} className="inline-flex items-center gap-1.5" style={{ fontSize: '13px', fontWeight: 600, color: '#1A1D1A' }}>
            {b.icon}
            {b.t}
          </span>
        ))}
      </div>
    </div>
  );
};

/** Частые вопросы сервиса — как на странице пополнения Steam. */
export const CodeFaq: React.FC<{ items: CodeFaqItem[] }> = ({ items }) => {
  const [open, setOpen] = useState<number | null>(null);
  return (
    <div>
      <h2 className="mb-3" style={{ fontFamily: 'Manrope, sans-serif', fontSize: '20px', fontWeight: 800, color: '#1A1D1A' }}>
        Частые вопросы
      </h2>
      <div className="space-y-2">
        {items.map((f, i) => (
          <div key={f.q} className="bg-white rounded-2xl border border-gray-200/80 overflow-hidden">
            <button
              onClick={() => setOpen(open === i ? null : i)}
              className="w-full px-4 py-3.5 flex items-center justify-between gap-3 text-left"
            >
              <span style={{ fontSize: '15px', fontWeight: 600, color: '#1A1D1A' }}>{f.q}</span>
              <span
                className="flex-shrink-0"
                style={{ fontSize: '20px', fontWeight: 600, color: BLUE, transform: open === i ? 'rotate(45deg)' : 'none', transition: 'transform 0.15s' }}
              >
                +
              </span>
            </button>
            {open === i && (
              <p className="px-4 pb-3.5" style={{ fontSize: '14px', lineHeight: '19px', color: '#818384', whiteSpace: 'pre-line' }}>{f.a}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
